
import { RevPopover, RevTooltip } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { tw } from '@core/tailwind'
import { COUNTRIES_WITH_EXTENDED_DISPLAY_PRICE } from '@product/components/constants'
import productTranslations from '@product/pages/product.translations'

import translations from '../AddToCart/AddToCart.translations'
import { HIGHLIGHTED_PICKERS_VARIANTS } from '../HighlightedPickers/HighlightedPickers.constants'

import AnimatedPrice from './AnimatedPrice/AnimatedPrice.vue'

const selectedHighlightedPickersTypeStyles = {
  [HIGHLIGHTED_PICKERS_VARIANTS.info]: tw`text-info`,
  [HIGHLIGHTED_PICKERS_VARIANTS.accent]: tw`text-accent`,
}

export default {
  components: {
    RevPopover,
    RevTooltip,
    AnimatedPrice,
  },
  props: {
    price: {
      type: Object,
      required: true,
    },
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    isVatIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
      experiments: 'experiments/getExperiments',
      breakpoint: 'breakpoint',
    }),
    isMobile() {
      return this.breakpoint < 2
    },
    priceType() {
      return this.selectedHighlightedPickers?.type
    },
    hasExtendedDisplay() {
      return COUNTRIES_WITH_EXTENDED_DISPLAY_PRICE.includes(this.country)
    },
    translations: () => translations,
    productTranslations: () => productTranslations,

    originalPriceDisplay() {
      if (this.hasExtendedDisplay) {
        return this.$t(translations.originalPriceDisplay, {
          price: this.$t.price(this.originalPrice),
        })
      }

      return this.$t.price(this.originalPrice)
    },

    isPriceCrossed() {
      return this.experiments.originalPriceCrossed !== 'priceIsNotCrossed'
    },

    shouldDisplayOriginalPrice() {
      return this.isPriceCrossed && !isEmpty(this.originalPrice)
    },

    priceStyle() {
      return (
        selectedHighlightedPickersTypeStyles[
          this.selectedHighlightedPickers?.type
        ] || tw`text-primary`
      )
    },
  },
}
